export const questionsModels = [
  {
    class: 'ineligible',
    field: 'femaleHRTBeluga_ineligible',
    label: "We're sorry you don't qualify",
    subLabel: "We're not able to prescribe for you today",
    type: 'info',
    extras: { sendToBeluga: false },
    isLast: true,
    blockQuestionFlow: true,
    answer: {}
  },
  {
    field: 'femaleHRTBeluga_complete',
    isLast: true,
    label: `Thank you for completing this questionnaire, please select "Finish" to submit`,
    extras: { sendToBeluga: false },
    type: 'info',
    answer: {}
  },
  {
    label: 'What was your sex assigned at birth?',
    field: 'femaleHRTBeluga_sexAssignedAtBirth',
    extras: {
      sendToBeluga: false
    },
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'femaleHRTBeluga_sexAssignedAtBirth_male',
          value: 'Male'
        },
        {
          key: 'femaleHRTBeluga_sexAssignedAtBirth_female',
          value: 'Female'
        }
      ]
    }
  },
  {
    label: 'Are you currently pregnant or planning to become pregnant?',
    field: 'femaleHRTBeluga_pregnancy',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'femaleHRTBeluga_pregnancy_yes',
          value: 'Yes'
        },
        {
          key: 'femaleHRTBeluga_pregnancy_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'Consent (Pregnancy)',
    educationalSlide: `I understand that the medication prescribed to me by my healthcare provider may not be safe to take during pregnancy. I acknowledge that taking this medication while pregnant could pose risks to my health and the health of a developing fetus.

I agree to take necessary precautions to avoid becoming pregnant while using this medication, including the use of effective contraception methods as discussed with my healthcare provider.

I understand that I should stop taking this medication before attempting to become pregnant. I agree to consult with my healthcare provider prior to discontinuing the medication and before planning a pregnancy to ensure my safety and well-being.

By selecting below, I confirm that I have read and understand the information provided above. I consent to proceed with the treatment under these conditions.`,
    field: 'femaleHRTBeluga_pregnancyConsent',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'femaleHRTBeluga_pregnancyConsent_disagree',
          class: 'option-decline',
          value: 'I have read the information and do NOT wish to proceed'
        },
        {
          key: 'femaleHRTBeluga_pregnancyConsent_agree',
          class: 'option-consent',
          value:
            'I have read and understand the above information, I understand the risks and wish to proceed'
        }
      ]
    }
  },
  {
    label: 'Is there any possibility of you being pregnant?',
    field: 'femaleHRTBeluga_pregnancyPossibility',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'femaleHRTBeluga_pregnancyPossibility_yes',
          value: 'Yes'
        },
        {
          key: 'femaleHRTBeluga_pregnancyPossibility_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'Are you currently breastfeeding?',
    field: 'femaleHRTBeluga_breastfeeding',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'femaleHRTBeluga_breastfeeding_yes',
          value: 'Yes'
        },
        {
          key: 'femaleHRTBeluga_breastfeeding_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label:
      'Have you noticed any changes in your menstrual cycle (e.g., irregular or absent periods) and other menopausal symptoms (such as hot flashes, night sweats), and do you believe you might be experiencing perimenopause or menopause?',
    field: 'femaleHRTBeluga_menopauseSymptoms',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'femaleHRTBeluga_menopauseSymptoms_yes',
          value: 'Yes'
        },
        {
          key: 'femaleHRTBeluga_menopauseSymptoms_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label:
      'Tell us more about the symptoms that you experience? (Check all that apply)',
    field: 'femaleHRTBeluga_symptomTypes',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'femaleHRTBeluga_symptomTypes_irregularPeriods',
          value: 'Irregular periods'
        },
        {
          key: 'femaleHRTBeluga_symptomTypes_hotFlashes',
          value: 'Hot flashes'
        },
        {
          key: 'femaleHRTBeluga_symptomTypes_nightSweats',
          value: 'Night sweats'
        },
        {
          key: 'femaleHRTBeluga_symptomTypes_moodSwings',
          value: 'Mood swings'
        },
        {
          key: 'femaleHRTBeluga_symptomTypes_sleepDisturbances',
          value: 'Sleep disturbances'
        },
        {
          key: 'femaleHRTBeluga_symptomTypes_reducedLibido',
          value: 'Reduce libido'
        },
        {
          key: 'femaleHRTBeluga_symptomTypes_vaginalDryness',
          value: 'Vaginal dryness'
        },
        {
          key: 'femaleHRTBeluga_symptomTypes_recurrentUTI',
          value: 'Recurrent urinary tract infections'
        },
        {
          key: 'femaleHRTBeluga_symptomTypes_drySkin',
          value: 'Dry skin'
        },
        {
          key: 'femaleHRTBeluga_symptomTypes_thinningHair',
          value: 'Thinning hair'
        },
        {
          key: 'femaleHRTBeluga_symptomTypes_weightGain',
          value: 'Weight gain around the abdomen'
        },
        {
          key: 'femaleHRTBeluga_symptomTypes_other',
          value: 'Other'
        },
        {
          key: 'femaleHRTBeluga_symptomTypes_none',
          value: 'None of these',
          uncheckOthers: true
        }
      ]
    }
  },
  {
    label: 'Tell us more about your other symptom(s)',
    field: 'femaleHRTBeluga_otherSymptoms',
    type: 'info',
    answer: {
      name: 'femaleHRTBeluga_otherSymptoms',
      type: 'text',
      placeholder: 'Describe your other symptoms'
    }
  },
  {
    label: 'How long have you experienced symptoms of menopause?',
    field: 'femaleHRTBeluga_symptomDuration',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'femaleHRTBeluga_symptomDuration_lessThan5',
          value: 'Less than 5 years'
        },
        {
          key: 'femaleHRTBeluga_symptomDuration_greaterThan5',
          value: 'Greater than 5 years'
        }
      ]
    }
  },
  {
    label:
      'Have you had a surgical resection of both of your ovaries (oophorectomy)?',
    field: 'femaleHRTBeluga_oophorectomy',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'femaleHRTBeluga_oophorectomy_yes',
          value: 'Yes'
        },
        {
          key: 'femaleHRTBeluga_oophorectomy_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label:
      'Please provide further information about why you have had your ovaries removed',
    field: 'femaleHRTBeluga_oophorectomyDetails',
    type: 'info',
    answer: {
      name: 'femaleHRTBeluga_oophorectomyDetails',
      type: 'text',
      placeholder: 'Provide details'
    }
  },
  {
    label: 'Have you had a surgical resection of your uterus (hysterectomy)?',
    field: 'femaleHRTBeluga_hysterectomy',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'femaleHRTBeluga_hysterectomy_yes',
          value: 'Yes'
        },
        {
          key: 'femaleHRTBeluga_hysterectomy_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label:
      'Please provide further information about why you have had a hysterectomy',
    field: 'femaleHRTBeluga_hysterectomyDetails',
    type: 'info',
    answer: {
      name: 'femaleHRTBeluga_hysterectomyDetails',
      type: 'text',
      placeholder: 'Provide details'
    }
  },
  {
    label: 'Do you experience any of the following? (Check all that apply)',
    field: 'femaleHRTBeluga_vaginalSymptoms',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'femaleHRTBeluga_vaginalSymptoms_painfulIntercourse',
          value: 'Painful intercourse'
        },
        {
          key: 'femaleHRTBeluga_vaginalSymptoms_vaginalDryness',
          value: 'Vaginal dryness'
        },
        {
          key: 'femaleHRTBeluga_vaginalSymptoms_vaginalIrritation',
          value: 'Vaginal irritation'
        },
        {
          key: 'femaleHRTBeluga_vaginalSymptoms_urinaryUrgency',
          value: 'Urinary urgency'
        },
        {
          key: 'femaleHRTBeluga_vaginalSymptoms_recurrentUTIs',
          value: 'Recurrent UTIs'
        },
        {
          key: 'femaleHRTBeluga_vaginalSymptoms_none',
          value: 'I do not experience any of these',
          uncheckOthers: true
        }
      ]
    }
  },
  {
    label:
      'Do you have thinning of your bones such as osteopenia or osteoporosis?',
    field: 'femaleHRTBeluga_boneThinning',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'femaleHRTBeluga_boneThinning_yes',
          value: 'Yes'
        },
        {
          key: 'femaleHRTBeluga_boneThinning_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'Please provide further information about your diagnosis',
    field: 'femaleHRTBeluga_boneThinningDetails',
    type: 'info',
    answer: {
      name: 'femaleHRTBeluga_boneThinningDetails',
      type: 'text',
      placeholder: 'Provide diagnosis details'
    }
  },
  {
    label: 'Are you CURRENTLY on hormone replacement therapy (HRT)?',
    field: 'femaleHRTBeluga_currentHRT',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'femaleHRTBeluga_currentHRT_yes',
          value: 'Yes'
        },
        {
          key: 'femaleHRTBeluga_currentHRT_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'What is your current HRT formulation?',
    field: 'femaleHRTBeluga_currentHRTFormulation',
    type: 'info',
    answer: {
      name: 'femaleHRTBeluga_currentHRTFormulation',
      type: 'text',
      placeholder: 'Describe your current HRT'
    }
  },
  {
    label: 'Have you ever experienced side effects from your HRT?',
    field: 'femaleHRTBeluga_hrtSideEffects',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'femaleHRTBeluga_hrtSideEffects_yes',
          value: 'Yes'
        },
        {
          key: 'femaleHRTBeluga_hrtSideEffects_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label:
      'Please tell us which product you had side effects to and what symptoms that you experienced',
    field: 'femaleHRTBeluga_hrtSideEffectsDetails',
    type: 'info',
    answer: {
      name: 'femaleHRTBeluga_hrtSideEffectsDetails',
      type: 'text',
      placeholder: 'Describe the side effects'
    }
  },
  {
    label: 'Have you EVER been on HRT in the PAST?',
    field: 'femaleHRTBeluga_pastHRT',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'femaleHRTBeluga_pastHRT_yes',
          value: 'Yes'
        },
        {
          key: 'femaleHRTBeluga_pastHRT_never',
          value: 'I have never been on birth control before'
        }
      ]
    }
  },
  {
    label: 'Provide further details of your previous HRT use',
    field: 'femaleHRTBeluga_pastHRTDetails',
    type: 'info',
    answer: {
      name: 'femaleHRTBeluga_pastHRTDetails',
      type: 'text',
      placeholder: 'Describe your previous HRT use'
    }
  },
  {
    label: 'Did you experience side effects from this?',
    field: 'femaleHRTBeluga_pastHRTSideEffects',
    type: 'info',
    answer: {
      name: 'femaleHRTBeluga_pastHRTSideEffects',
      type: 'text',
      placeholder: 'Describe any side effects'
    }
  },
  {
    label:
      'Do you have or have you had any of the following? (Select all that apply)',
    field: 'femaleHRTBeluga_medicalHistory',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'femaleHRTBeluga_medicalHistory_bloodPressure',
          value: 'Blood Pressure Disorder'
        },
        {
          key: 'femaleHRTBeluga_medicalHistory_neurological',
          value: 'Neurological Disorder or Chronic Headaches'
        },
        {
          key: 'femaleHRTBeluga_medicalHistory_psychiatric',
          value: 'Psychiatric Illness'
        },
        {
          key: 'femaleHRTBeluga_medicalHistory_cholesterol',
          value: 'Cholesterol Disorder'
        },
        {
          key: 'femaleHRTBeluga_medicalHistory_seizures',
          value: 'Seizures or Epilepsy'
        },
        {
          key: 'femaleHRTBeluga_medicalHistory_gallbladder',
          value: 'Current or recent gallbladder issues'
        },
        {
          key: 'femaleHRTBeluga_medicalHistory_bloodClotting',
          value: 'Inherited Blood Clotting Disorder'
        },
        {
          key: 'femaleHRTBeluga_medicalHistory_lupus',
          value:
            'Systemic Lupus Erythematous WITH positive antiphospholipid antibodies (lupus anticoagulant, anticardiolipin antibody, anti-β2-glycoprotein)'
        },
        {
          key: 'femaleHRTBeluga_medicalHistory_none',
          value: 'None of these',
          uncheckOthers: true
        }
      ]
    }
  },
  {
    label: 'Tell us more about your condition',
    field: 'femaleHRTBeluga_medicalHistoryDetails',
    type: 'info',
    answer: {
      name: 'femaleHRTBeluga_medicalHistoryDetails',
      type: 'text',
      placeholder: 'Provide details about your condition'
    }
  },
  {
    label:
      'Over the past 6 months, have you had ABNORMAL and UNDIAGNOSED vaginal bleeding that is different from your usual period?',
    field: 'femaleHRTBeluga_abnormalBleeding',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'femaleHRTBeluga_abnormalBleeding_yes',
          value: 'Yes'
        },
        {
          key: 'femaleHRTBeluga_abnormalBleeding_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label:
      'Do you have a known diagnosis of liver cirrhosis or liver failures?',
    field: 'femaleHRTBeluga_liverDisease',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'femaleHRTBeluga_liverDisease_yes',
          value: 'Yes'
        },
        {
          key: 'femaleHRTBeluga_liverDisease_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label:
      'Have you ever had a deep vein thrombosis (DVT) or pulmonary embolism (PE-blood clot in the lung)?',
    field: 'femaleHRTBeluga_bloodClots',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'femaleHRTBeluga_bloodClots_yes',
          value: 'Yes'
        },
        {
          key: 'femaleHRTBeluga_bloodClots_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label:
      'Have you been diagnosed with breast cancer, uterine cancer, or any hormone-sensitive cancers?',
    field: 'femaleHRTBeluga_hormoneSensitiveCancer',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'femaleHRTBeluga_hormoneSensitiveCancer_yes',
          value: 'Yes'
        },
        {
          key: 'femaleHRTBeluga_hormoneSensitiveCancer_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label:
      'Do you have a strong FAMILY History of breast cancer, uterine cancer, or any hormone-sensitive cancers?',
    field: 'femaleHRTBeluga_familyCancerHistory',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'femaleHRTBeluga_familyCancerHistory_yes',
          value: 'Yes'
        },
        {
          key: 'femaleHRTBeluga_familyCancerHistory_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label:
      'Do you have a known history of coronary artery disease, stroke, or "mini stroke" known as a transient ischemic attack (TIA)?',
    field: 'femaleHRTBeluga_cardiovascularHistory',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'femaleHRTBeluga_cardiovascularHistory_yes',
          value: 'Yes'
        },
        {
          key: 'femaleHRTBeluga_cardiovascularHistory_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'Do you currently use nicotine products?',
    field: 'femaleHRTBeluga_nicotineUse',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'femaleHRTBeluga_nicotineUse_yes',
          value: 'Yes'
        },
        {
          key: 'femaleHRTBeluga_nicotineUse_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'Are you currently taking any of the following medications?',
    field: 'femaleHRTBeluga_medications',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'femaleHRTBeluga_medications_carbamazepine',
          value: 'Carbamazepine'
        },
        {
          key: 'femaleHRTBeluga_medications_felbamate',
          value: 'Felbamate'
        },
        {
          key: 'femaleHRTBeluga_medications_oxcarbazepine',
          value: 'Oxcarbazepine'
        },
        {
          key: 'femaleHRTBeluga_medications_phenytoin',
          value: 'Phenytoin'
        },
        {
          key: 'femaleHRTBeluga_medications_primidone',
          value: 'Primidone'
        },
        {
          key: 'femaleHRTBeluga_medications_rufinamide',
          value: 'Rufinamide'
        },
        {
          key: 'femaleHRTBeluga_medications_topiramate',
          value: 'Topiramate (> 200mg/day)'
        },
        {
          key: 'femaleHRTBeluga_medications_lamotrigine',
          value: 'Lamotrigine'
        },
        {
          key: 'femaleHRTBeluga_medications_stjohnsWort',
          value: "St. John's Wort"
        },
        {
          key: 'femaleHRTBeluga_medications_rifampin',
          value: 'Rifampin'
        },
        {
          key: 'femaleHRTBeluga_medications_rifabutin',
          value: 'Rifabutin'
        },
        {
          key: 'femaleHRTBeluga_medications_barbiturates',
          value: 'Barbiturates'
        },
        {
          key: 'femaleHRTBeluga_medications_bosentan',
          value: 'Bosentan'
        },
        {
          key: 'femaleHRTBeluga_medications_none',
          value: 'None apply',
          uncheckOthers: true
        }
      ]
    }
  },
  {
    label: 'What has your blood pressure been over the last six months?',
    field: 'femaleHRTBeluga_bloodPressure',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'femaleHRTBeluga_bloodPressure_veryLow',
          value: '<90/50'
        },
        {
          key: 'femaleHRTBeluga_bloodPressure_normal',
          value: '90-139/50-89'
        },
        {
          key: 'femaleHRTBeluga_bloodPressure_elevated',
          value: '140-159/90-99'
        },
        {
          key: 'femaleHRTBeluga_bloodPressure_high',
          value: '160/100 or above'
        },
        {
          key: 'femaleHRTBeluga_bloodPressure_alwaysNormal',
          value: 'My blood pressure has always been normal'
        },
        {
          key: 'femaleHRTBeluga_bloodPressure_unknown',
          value: "I don't know my blood pressure"
        }
      ]
    }
  },
  {
    label: 'Do you have an adhesive allergy?',
    field: 'femaleHRTBeluga_adhesiveAllergy',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'femaleHRTBeluga_adhesiveAllergy_yes',
          value: 'Yes'
        },
        {
          key: 'femaleHRTBeluga_adhesiveAllergy_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'What other information or questions do you have for the doctor?',
    field: 'femaleHRTBeluga_additionalInfo',
    type: 'info',
    answer: {
      name: 'femaleHRTBeluga_additionalInfo',
      type: 'text',
      placeholder: 'Additional information or questions'
    }
  },
  {
    label: 'Consent (Hormone Replacement Therapy (HRT))',
    educationalSlide: `This consent form provides information about the hormone replacement therapy (HRT) prescribed to you by your healthcare provider. It is important to understand the purpose, potential benefits, risks, side effects, and your responsibilities while undergoing this treatment. Please read the following information carefully.

Purpose and Benefits
Hormone replacement therapy with estradiol and progesterone is used to manage menopause-related symptoms and improve quality of life. Estradiol replaces declining estrogen levels, while progesterone helps protect the uterine lining from overgrowth. HRT may provide relief from the following symptoms:
➢ Hot flashes and night sweats
➢ Vaginal dryness and discomfort during intercourse
➢ Sleep disturbances
➢ Mood changes, irritability, and anxiety
➢ Bone density loss associated with osteoporosis
In addition, HRT may help reduce the risk of fractures in postmenopausal women.

Potential Risks and Side Effects
HRT is generally safe for many women, but like all medications, it carries potential risks and side effects. These vary depending on individual health factors and treatment duration.

Common side effects may include:
➢ Nausea or upset stomach
➢ Breast tenderness or swelling
➢ Spotting or breakthrough bleeding
➢ Bloating or fluid retention
➢ Headaches or mood changes

Rare but serious risks may include:
➢ Blood clots, which can lead to stroke, deep vein thrombosis, pulmonary embolism, and/or death
➢ Increased risk of breast cancer (with long-term use in some women)
➢ Gallbladder disease
➢ Cardiovascular issues, including heart attack (primarily in women starting HRT later in menopause)

If you experience severe symptoms, such as chest pain, difficulty breathing, sudden leg swelling, intense headaches, or yellowing of the skin or eyes, seek immediate medical attention.

Monitoring Plan
Your healthcare provider will monitor your progress and response to HRT to ensure its continued safety and effectiveness. It is strongly recommended that you continue:
➢ Periodic physical examinations and blood pressure checks
➢ Mammograms and pelvic ultrasounds as needed
➢ Routine blood tests to assess liver function

Alternative Treatments
You have the right to discuss alternative approaches to managing menopause symptoms, including:
➢ Non-hormonal medications
➢ Lifestyle changes (e.g., diet, exercise, stress management)
➢ Herbal supplements
➢ Localized treatments for vaginal symptoms (e.g., estrogen creams or rings)

Your Responsibilities
As a patient, you are responsible for:
➢ Following the instructions for using your medication as directed
➢ Attending all follow-up appointments and undergoing recommended testing.
➢ Informing your provider of any new medications, supplements, or changes in your health.
➢ Reporting any concerning side effects or symptoms immediately.

Consent
By selecting below, you confirm that you have read and understood the information provided. You acknowledge the potential benefits and risks associated with the prescribed hormone therapy.. You agree to adhere to the recommended use, monitoring plan, and to communicate openly with your healthcare provider about any concerns.`,
    field: 'femaleHRTBeluga_hrtConsent',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'femaleHRTBeluga_hrtConsent_disagree',
          class: 'option-decline',
          value:
            'I have read the above information, and I do NOT wish to proceed.'
        },
        {
          key: 'femaleHRTBeluga_hrtConsent_agree',
          class: 'option-consent',
          value:
            'I have read the above information, I understand the risks, and I would like to proceed.'
        }
      ]
    }
  },
  {
    field: 'femaleHRTBeluga_truthfulnessConsent',
    type: 'select',
    label: 'Consent (Truthfulness)',
    educationalSlide: `Please attest to the following confirming that all information you have provided to us is true and complete.
    
    Consent: I verify that I am the patient and that I have answered the questions asked in this intake form. I confirm that I have reviewed and understood all the questions asked of me. I attest that the answers and information I have provided in this questionnaire is true and complete to the best of my knowledge. I understand that it is critical to my health to share complete health information with my doctor. I will not hold the doctor or affiliated medical practice responsible for any oversights or omissions, whether intentional or not, in the information that I provided.`,
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'femaleHRTBeluga_truthfulnessConsent_disagree',
          class: 'option-decline',
          value:
            'I have read the above information and I do not wish to continue'
        },
        {
          key: 'femaleHRTBeluga_truthfulnessConsent_agree',
          class: 'option-consent',
          value:
            'I have read the above information and I do consent and wish to move forward'
        }
      ]
    }
  }
] as const;
export default questionsModels;
